/* Daily announcement timer. Recalculate local midnight each tick so it resets
   without a reload and stays accurate after sleep, tab suspension or DST. */
(function () {
  'use strict';
  var timers = Array.prototype.slice.call(document.querySelectorAll('[data-daily-countdown]')).filter(function (timer) {
    if (timer.dataset.countdownReady) return false;
    timer.dataset.countdownReady = 'true';
    return true;
  });
  if (!timers.length) return;

  function updateCountdown() {
    var now = new Date();
    var midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);
    var remaining = Math.max(0, Math.ceil((midnight.getTime() - now.getTime()) / 1000));
    var values = [Math.floor(remaining / 3600), Math.floor(remaining / 60) % 60, remaining % 60];
    var units = ['hours', 'minutes', 'seconds'];
    timers.forEach(function (timer) {
      units.forEach(function (unit, index) {
        var field = timer.querySelector('[data-countdown-' + unit + ']');
        var text = String(values[index]).padStart(2, '0');
        if (field && field.textContent !== text) field.textContent = text;
      });
      timer.hidden = false;
    });
  }

  updateCountdown();
  window.setInterval(updateCountdown, 1000);

  // Show the sale line at the very top of the page and the countdown once the visitor scrolls.
  var bar = document.querySelector('[data-ann]');
  if (bar) {
    var queued = false;
    var syncBar = function () {
      queued = false;
      bar.classList.toggle('is-scrolled', window.scrollY > 24);
    };
    window.addEventListener('scroll', function () {
      if (!queued) { queued = true; window.requestAnimationFrame(syncBar); }
    }, { passive: true });
    window.addEventListener('pageshow', syncBar);
    syncBar();
  }
  window.addEventListener('pageshow', updateCountdown);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) updateCountdown();
  });
})();

/* Misu — Plain Speech.
   The page renders complete without this file. `.anim` is set pre-paint and
   only ever ADDS from-states, so nothing is hidden pending motion. */

(function () {
  'use strict';
  var root = document.documentElement;

  /* mobile menu */
  var burger = document.getElementById('burger');
  var mnav = document.getElementById('mnav');
  function positionMenu() {
    if (!burger || !mnav || innerWidth <= 900) return;
    var trigger = burger.getBoundingClientRect();
    mnav.style.setProperty('--menu-top', Math.round(trigger.bottom + 8) + 'px');
    mnav.style.setProperty('--menu-left', Math.round(trigger.left) + 'px');
  }
  function setMenu(open) {
    if (!burger || !mnav) return;
    burger.setAttribute('aria-expanded', String(open));
    burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    mnav.hidden = !open;
    if (open) positionMenu();
    document.body.style.overflow = open && innerWidth <= 900 ? 'hidden' : '';
  }
  if (burger && mnav) {
    burger.addEventListener('click', function () {
      setMenu(burger.getAttribute('aria-expanded') !== 'true');
    });
    mnav.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });
    document.addEventListener('click', function (e) {
      if (burger.getAttribute('aria-expanded') === 'true' && !burger.contains(e.target) && !mnav.contains(e.target)) setMenu(false);
    });
    addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') { setMenu(false); burger.focus(); }
    });
    addEventListener('resize', function () {
      if (burger.getAttribute('aria-expanded') === 'true') {
        if (innerWidth > 900) positionMenu();
        document.body.style.overflow = innerWidth <= 900 ? 'hidden' : '';
      }
    });
  }

  /* scroll reveals */
  if (root.classList.contains('anim')) {
    var targets = [].slice.call(document.querySelectorAll(
      '.ey, main h2, .rail-strip ul, .sw, .home-use__image, .home-use__directions, .home-clarity__lists, .home-box__items, .home-v2__section-head, .home-v2__steps, .home-v2__food-grid, .home-v2__taste-grid, .home-v2__box-card, .home-v2__control-grid, .faq__l, .home-shop__inner, .ft__top'
    ));
    targets.forEach(function (el) { el.classList.add('reveal'); });
    var scrolled = false;
    var show = function () {
      var h = innerHeight || 800;
      targets.forEach(function (el) {
        if (!el.classList.contains('is-in') && el.getBoundingClientRect().top < h * 0.9) el.classList.add('is-in');
      });
    };
    addEventListener('scroll', function () { scrolled = true; show(); }, { passive: true });
    addEventListener('resize', show);
    show();
    setTimeout(function () { if (!scrolled) targets.forEach(function (el) { el.classList.add('is-in'); }); }, 2500);
  }

  /* sticky buy bar — carries the real billed total, not a monthly equivalent */
  var bar = document.getElementById('mobar');
  var heroCta = document.querySelector('.home-v2__hero .btn, .hero .btn');
  var shop = document.querySelector('.home-v2__close, #shop');
  if (!bar || !heroCta || !shop) return;
  var sync = function () {
    if (!matchMedia('(max-width: 900px)').matches) { bar.classList.remove('is-on'); return; }
    var r = shop.getBoundingClientRect();
    bar.classList.toggle('is-on', heroCta.getBoundingClientRect().bottom < 0 && !(r.top < innerHeight && r.bottom > 0));
  };
  addEventListener('scroll', sync, { passive: true });
  addEventListener('resize', sync);
  sync();
})();

/* Five reasons carousel: responsive pages, controls and native swipe. */
(function () {
  'use strict';

  var track = document.querySelector('[data-reasons-track]');
  var previous = document.querySelector('[data-reasons-prev]');
  var next = document.querySelector('[data-reasons-next]');
  var dots = document.querySelector('[data-reasons-dots]');
  if (!track || !previous || !next || !dots) return;

  var cards = [].slice.call(track.querySelectorAll('article'));
  var pageCount = 0;
  var scrollTicking = false;

  function measurements() {
    var card = cards[0];
    var gap = parseFloat(getComputedStyle(track).gap || 0);
    var step = card ? card.getBoundingClientRect().width + gap : 1;
    var visible = Math.max(1, Math.floor((track.clientWidth + gap) / step));
    return { step: step, pages: Math.max(1, cards.length - visible + 1) };
  }

  function currentPage(step, pages) {
    return Math.max(0, Math.min(pages - 1, Math.round(track.scrollLeft / step)));
  }

  function paint() {
    var size = measurements();
    if (size.pages !== pageCount) {
      pageCount = size.pages;
      dots.innerHTML = '';
      for (var index = 0; index < pageCount; index += 1) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Go to carousel page ' + (index + 1));
        dot.dataset.page = String(index);
        dots.appendChild(dot);
      }
    }

    var active = currentPage(size.step, size.pages);
    [].slice.call(dots.children).forEach(function (dot, index) {
      dot.setAttribute('aria-current', String(index === active));
    });
    previous.disabled = active === 0;
    next.disabled = active === size.pages - 1;
  }

  function goTo(page) {
    var size = measurements();
    var target = Math.max(0, Math.min(size.pages - 1, page));
    var reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollTo({ left: target * size.step, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  previous.addEventListener('click', function () {
    var size = measurements();
    goTo(currentPage(size.step, size.pages) - 1);
  });
  next.addEventListener('click', function () {
    var size = measurements();
    goTo(currentPage(size.step, size.pages) + 1);
  });
  dots.addEventListener('click', function (event) {
    var dot = event.target.closest('button[data-page]');
    if (dot) goTo(Number(dot.dataset.page));
  });
  track.addEventListener('scroll', function () {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(function () {
      paint();
      scrollTicking = false;
    });
  }, { passive: true });
  addEventListener('resize', paint);
  paint();
})();

/* Mobile-first AJAX cart drawer. The cart page remains the no-JavaScript fallback. */
(function () {
  'use strict';

  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;
  var lastTrigger = null;

  function panel() { return drawer.querySelector('[data-cart-drawer-panel]'); }

  function bindCloseButtons() {
    [].slice.call(drawer.querySelectorAll('[data-cart-close]')).forEach(function (button) {
      button.addEventListener('click', closeCart);
    });
  }

  function openCart(trigger) {
    lastTrigger = trigger || document.activeElement;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-is-open');
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      var activePanel = panel();
      if (activePanel) activePanel.focus();
    });
  }

  function closeCart() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-is-open');
    setTimeout(function () { drawer.hidden = true; }, 260);
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  function refreshCart(openAfter, trigger) {
    return fetch('/cart?view=drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) { if (!response.ok) throw new Error('Cart unavailable'); return response.text(); })
      .then(function (html) {
        var oldPanel = panel();
        if (oldPanel) oldPanel.outerHTML = html;
        var countText = (panel() && panel().querySelector('#CartDrawerTitle span')) ? panel().querySelector('#CartDrawerTitle span').textContent : '(0)';
        var count = Number((countText.match(/\d+/) || ['0'])[0]);
        [].slice.call(document.querySelectorAll('[data-cart-count]')).forEach(function (badge) {
          badge.textContent = count;
          badge.hidden = count === 0;
        });
        bindCloseButtons();
        if (openAfter) openCart(trigger);
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-cart-open]');
    if (!trigger || !matchMedia('(max-width: 900px)').matches) return;
    event.preventDefault();
    refreshCart(true, trigger).catch(function () { location.href = trigger.href; });
  });

  document.addEventListener('submit', function (event) {
    if (document.getElementById('MisuCartConfig')) return;
    var productForm = event.target.closest('form[action*="/cart/add"]');
    if (!productForm || productForm.hasAttribute('data-direct-checkout') || !matchMedia('(max-width: 900px)').matches || !window.fetch || !window.FormData) return;
    event.preventDefault();
    var submitButton = productForm.querySelector('[type="submit"]');
    if (submitButton) submitButton.disabled = true;
    var productData = new FormData(productForm);
    var landing = window.MisuLanding ? window.MisuLanding.attributes() : {};
    Object.keys(landing).forEach(function (key) { productData.append('attributes[' + key + ']', landing[key]); });
    fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, body: productData })
      .then(function (response) { if (!response.ok) throw new Error('Unable to add'); return response.json(); })
      .then(function () { window.location.assign('/checkout'); })
      .catch(function () { productForm.submit(); })
      .finally(function () { if (submitButton) submitButton.disabled = false; });
  });

  addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeCart();
    if (event.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
    var focusable = [].slice.call(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'));
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  bindCloseButtons();
})();

/* Ingredient cards flip in place without shifting the section. */
(function () {
  'use strict';

  var cards = [].slice.call(document.querySelectorAll('.product-food-card'));
  cards.forEach(function (card) {
    card.addEventListener('click', function () {
      var next = !card.classList.contains('is-flipped');
      card.classList.toggle('is-flipped', next);
      card.setAttribute('aria-pressed', String(next));
    });
  });

  var outcomeCards = [].slice.call(document.querySelectorAll('.product-outcome-card'));
  outcomeCards.forEach(function (card) {
    card.addEventListener('click', function () {
      var next = !card.classList.contains('is-flipped');
      card.classList.toggle('is-flipped', next);
      card.setAttribute('aria-pressed', String(next));
    });
  });
  // Card explanations fit cleanly inside the back face without internal scrollbars.
})();

/* Keep starter subscriptions and their first-order gifts together when removed. */
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-remove-misu-starter]');
    if (!trigger || !window.fetch) return;
    event.preventDefault();
    var fallbackUrl = trigger.href;
    trigger.setAttribute('aria-disabled', 'true');

    fetch('/cart.js', {
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
    })
      .then(function (response) { if (!response.ok) throw new Error('Unable to inspect cart'); return response.json(); })
      .then(function (cart) {
        var updates = {};
        (cart.items || []).forEach(function (item) {
          var properties = item.properties || {};
          if (item.sku === 'MISU-KIT-30-OG' || item.sku === 'MISU-KIT-90-OG' || item.sku === 'MISU-KIT-3-MONTHLY-OG' || item.sku === 'MISU-KIT-5-MONTHLY-OG' || properties._misu_starter_gift === 'true') {
            updates[item.key] = 0;
          }
        });
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function (response) { if (!response.ok) throw new Error('Unable to remove starter offer'); window.location.reload(); })
      .catch(function () { window.location.assign(fallbackUrl); });
  });
})();

/* Product gallery, variant state, purchase options and mobile purchase bar. */
(function () {
  'use strict';

  var form = document.getElementById('ProductForm');
  if (!form) return;

  var mainImage = document.getElementById('ProductMainImage');
  var thumbs = [].slice.call(document.querySelectorAll('[data-gallery-src]'));
  var galleryTrack = document.querySelector('.product-gallery__thumbs');
  var galleryRequest = 0;
  var displayedThumb = thumbs.filter(function (thumb) { return thumb.classList.contains('is-active'); })[0];

  function markGalleryThumb(thumb) {
    thumbs.forEach(function (item) {
      item.classList.toggle('is-active', item === thumb);
      item.setAttribute('aria-pressed', String(item === thumb));
    });
  }

  function centerGalleryThumb(thumb) {
    var track = thumb.closest('.product-gallery__thumbs');
    if (!track) return;

    var trackBox = track.getBoundingClientRect();
    var thumbBox = thumb.getBoundingClientRect();
    var target = track.scrollLeft + (thumbBox.left - trackBox.left) - ((trackBox.width - thumbBox.width) / 2);
    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

    track.scrollTo({
      left: Math.max(0, Math.min(target, maxScroll)),
      behavior: 'smooth'
    });
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImage) return;
      var request = ++galleryRequest;
      markGalleryThumb(thumb);
      centerGalleryThumb(thumb);
      mainImage.classList.add('is-changing');
      var nextImage = new Image();
      nextImage.onload = function () {
        if (request !== galleryRequest) return;
        mainImage.src = thumb.getAttribute('data-gallery-src');
        mainImage.removeAttribute('srcset');
        mainImage.alt = thumb.getAttribute('data-gallery-alt') || '';
        displayedThumb = thumb;
        mainImage.classList.remove('is-changing');
      };
      nextImage.onerror = function () {
        if (request !== galleryRequest) return;
        markGalleryThumb(displayedThumb);
        mainImage.classList.remove('is-changing');
      };
      nextImage.src = thumb.getAttribute('data-gallery-src');
    });

    thumb.addEventListener('focus', function () {
      // Pointer focus fires before click; moving the thumbnail then can cancel the tap.
      if (thumb.matches(':focus-visible')) centerGalleryThumb(thumb);
    });
  });

  var variantInput = document.getElementById('ProductVariant');
  var sellingPlanInput = document.getElementById('SellingPlan');
  var cadenceInputs = [].slice.call(document.querySelectorAll('input[name="cadence"]'));
  var variantsNode = document.getElementById('ProductVariants');
  var price = document.getElementById('ProductPrice');
  var comparePrice = document.getElementById('ProductCompare');
  var saveAmount = document.getElementById('ProductSave');
  var add = document.getElementById('ProductAdd');
  var addLabel = document.getElementById('ProductAddLabel');
  var addPrice = document.getElementById('ProductAddPrice');
  var addCompare = document.getElementById('ProductAddCompare');
  var sticky = document.getElementById('ProductSticky');
  var stickyButton = sticky ? sticky.querySelector('button') : null;
  var stickyPrice = document.getElementById('ProductStickyPrice');
  var stickyLabel = document.getElementById('ProductStickyLabel');
  var refillCadence = document.getElementById('ProductRefillCadence');
  var variants = [];
  try { variants = variantsNode ? JSON.parse(variantsNode.textContent) : []; } catch (error) { variants = []; }

  function money(cents) {
    var amount = Number(cents || 0) / 100;
    if (!Number.isFinite(amount)) amount = 0;
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
    }).format(amount).replace(/\.00$/, '');
  }

  function syncCadence(input) {
    if (!input || !variantInput || !sellingPlanInput) return;
    variantInput.value = input.getAttribute('data-variant-id') || '';
    sellingPlanInput.value = input.getAttribute('data-selling-plan') || '';
    var selected = variants.find(function (variant) { return String(variant.id) === variantInput.value; });
    if (!selected) return;
    var displayedPrice = Number(input.getAttribute('data-price') || selected.price || 0);
    var comparison = Number(input.getAttribute('data-compare') || selected.compare_at_price || 0);
    var formatted = money(displayedPrice);
    if (price) price.textContent = formatted;
    if (comparePrice) {
      var hasComparison = comparison > displayedPrice;
      comparePrice.hidden = !hasComparison;
      if (hasComparison) comparePrice.textContent = money(comparison);
      if (saveAmount) {
        saveAmount.hidden = !hasComparison;
        if (hasComparison) saveAmount.textContent = 'Fall Sale · Save ' + Math.round(((comparison - displayedPrice) / comparison) * 100) + '%';
      }
    }
    if (addPrice) addPrice.textContent = formatted;
    if (addCompare) {
      addCompare.hidden = comparison <= displayedPrice;
      if (comparison > displayedPrice) addCompare.textContent = money(comparison);
    }
    if (stickyPrice) stickyPrice.textContent = formatted + ' today';
    if (stickyLabel) stickyLabel.textContent = input.getAttribute('data-offer-label') || 'Buy 1 Pouch';
    if (refillCadence) refillCadence.textContent = 'Refills Ship Every 30 Days';
    cadenceInputs.forEach(function (option) {
      var label = option.closest('.product-cadence__option');
      if (label) label.classList.toggle('is-selected', option === input);
    });
    var canPurchase = !input.disabled && selected.available && Boolean(sellingPlanInput.value);
    if (add) add.disabled = !canPurchase;
    if (stickyButton) stickyButton.disabled = !canPurchase;
    if (addLabel) addLabel.textContent = canPurchase ? 'Add to Cart' : 'Sold Out';
    if (history.replaceState) {
      var nextUrl = new URL(location.href);
      nextUrl.searchParams.set('variant', selected.id);
      history.replaceState({}, '', nextUrl.pathname + nextUrl.search + nextUrl.hash);
    }
  }
  cadenceInputs.forEach(function (input) {
    input.addEventListener('change', function () { syncCadence(input); });
  });
  var requestedVariant = new URLSearchParams(location.search).get('variant');
  var initialCadence = cadenceInputs.find(function (input) { return !input.disabled && input.getAttribute('data-variant-id') === requestedVariant; }) || cadenceInputs.find(function (input) { return input.checked; });
  if (initialCadence) initialCadence.checked = true;
  if (initialCadence) syncCadence(initialCadence);

  form.addEventListener('submit', function (event) {
    if (document.getElementById('MisuCartConfig')) return;
    if (!form.hasAttribute('data-misu-starter-cart') || !window.fetch) return;
    event.preventDefault();
    event.stopPropagation();
    if (form.getAttribute('data-submitting') === 'true') return;
    form.setAttribute('data-submitting', 'true');
    var originalLabel = addLabel ? addLabel.textContent : '';
    if (addLabel) addLabel.textContent = 'Preparing your box…';
    if (add) add.disabled = true;
    if (stickyButton) {
      stickyButton.disabled = true;
      var stickyButtonLabel = stickyButton.querySelector('span');
      if (stickyButtonLabel) stickyButtonLabel.textContent = 'Preparing…';
    }
    var starterVariantIds = cadenceInputs
      .map(function (input) { return Number(input.getAttribute('data-variant-id')); })
      .filter(Boolean);
    var giftVariantIds = [
      Number(form.getAttribute('data-gift-spoon-variant')),
      Number(form.getAttribute('data-gift-frother-variant'))
    ].filter(Boolean);
    var removeExistingStarterLines = fetch('/cart.js', {
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
    })
      .then(function (response) { if (!response.ok) throw new Error('Unable to inspect cart'); return response.json(); })
      .then(function (cart) {
        var updates = {};
        (cart.items || []).forEach(function (item) {
          var properties = item.properties || {};
          if (starterVariantIds.indexOf(Number(item.variant_id)) !== -1 || giftVariantIds.indexOf(Number(item.variant_id)) !== -1 || properties._misu_starter_gift === 'true') {
            updates[item.key] = 0;
          }
        });
        if (!Object.keys(updates).length) return null;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates: updates })
        }).then(function (response) {
          if (!response.ok) throw new Error('Unable to replace existing selection');
          return response.json();
        });
      });

    removeExistingStarterLines.then(function () {
      var selectedVariantId = Number(variantInput && variantInput.value);
      var selectedSellingPlan = Number(sellingPlanInput && sellingPlanInput.value);
      if (!selectedVariantId || !selectedSellingPlan || giftVariantIds.length !== 2) {
        throw new Error('Starter offer configuration is incomplete');
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: window.MisuLanding ? window.MisuLanding.attributes() : {},
          items: [
            {
              id: giftVariantIds[1],
              quantity: 1,
              properties: { _misu_starter_gift: 'true', _misu_gift_name: 'Premium handheld frother' }
            },
            {
              id: giftVariantIds[0],
              quantity: 1,
              properties: { _misu_starter_gift: 'true', _misu_gift_name: 'Walnut measuring scoop' }
            },
            {
              id: selectedVariantId,
              quantity: 1,
              selling_plan: selectedSellingPlan,
              properties: { _misu_first_order_offer: 'true' }
            }
          ]
        })
      });
    })
      .then(function (response) { if (!response.ok) throw new Error('Unable to add'); return response.json(); })
      .then(function () { window.location.assign('/checkout'); })
      .catch(function () {
        form.removeAttribute('data-submitting');
        if (addLabel) addLabel.textContent = originalLabel;
        if (add) add.disabled = false;
        if (stickyButton) {
          stickyButton.disabled = false;
          var stickyButtonLabel = stickyButton.querySelector('span');
          if (stickyButtonLabel) stickyButtonLabel.textContent = 'Start now';
        }
        window.alert('We could not open checkout. Please try again.');
      });
  });

  if (sticky && add) {
    var productClose = document.querySelector('.product-close');
    var syncSticky = function () {
      var rect = add.getBoundingClientRect();
      var closeRect = productClose ? productClose.getBoundingClientRect() : null;
      var closeVisible = closeRect && closeRect.top < innerHeight && closeRect.bottom > 0;
      var passedPrimaryCta = rect.bottom < 0;
      sticky.classList.toggle('is-on', passedPrimaryCta && !closeVisible);
    };
    addEventListener('scroll', syncSticky, { passive: true });
    addEventListener('resize', syncSticky);
    syncSticky();
  }
})();

/* Sell-through meter: render final target immediately so it never flashes 0% sold. */
(function () {
  'use strict';

  var meters = [].slice.call(document.querySelectorAll('[data-stock-progress]'));
  if (!meters.length) return;

  function finish(meter) {
    var count = meter.querySelector('[data-stock-count]');
    var target = Number(meter.getAttribute('data-stock-value') || 93);
    meter.classList.add('is-animated');
    if (count) count.textContent = String(target);
  }

  meters.forEach(finish);
})();

/* Credibility counters: render final formatted values immediately so stats never read 0+ / 0% / 0. */
(function () {
  'use strict';

  var counters = [].slice.call(document.querySelectorAll('[data-count]'));
  if (!counters.length) return;

  function finalValue(counter) {
    return Number(counter.getAttribute('data-count') || 0).toLocaleString(document.documentElement.lang || 'en-US') + (counter.getAttribute('data-suffix') || '');
  }

  counters.forEach(function (counter) { counter.textContent = finalValue(counter); });
})();

/* Long-horizon journey: fill the vertical rail and reveal each stage. */
(function () {
  'use strict';

  var track = document.querySelector('[data-journey-track]');
  if (!track) return;
  var stages = [].slice.call(track.children);
  var reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reducedMotion) {
    track.style.setProperty('--journey-progress', '1');
    stages.forEach(function (stage) { stage.classList.add('is-active'); });
    return;
  }

  function updateJourney() {
    var rect = track.getBoundingClientRect();
    var viewportMarker = innerHeight * 0.68;
    var progress = Math.max(0, Math.min(1, (viewportMarker - rect.top) / Math.max(rect.height, 1)));
    track.style.setProperty('--journey-progress', progress.toFixed(3));

    stages.forEach(function (stage, index) {
      var node = stage.querySelector('i');
      var nodeTop = node ? node.getBoundingClientRect().top : stage.getBoundingClientRect().top;
      stage.classList.toggle('is-active', nodeTop <= viewportMarker || (index === 0 && rect.top < innerHeight * 0.86));
    });
  }

  var ticking = false;
  function requestJourneyUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      updateJourney();
      ticking = false;
    });
  }

  addEventListener('scroll', requestJourneyUpdate, { passive: true });
  addEventListener('resize', requestJourneyUpdate);
  updateJourney();
})();

/* Customer story carousel: one-card movement with native touch scrolling. */
(function () {
  'use strict';

  var track = document.querySelector('[data-story-track]');
  var previous = document.querySelector('[data-story-prev]');
  var next = document.querySelector('[data-story-next]');
  if (!track || !previous || !next) return;

  function move(direction) {
    var card = track.querySelector('article');
    if (!card) return;
    var gap = parseFloat(getComputedStyle(track).gap || 0);
    var step = card.getBoundingClientRect().width + gap;
    var current = Math.round(track.scrollLeft / step);
    track.scrollTo({ left: (current + direction) * step, behavior: 'smooth' });
  }

  previous.addEventListener('click', function () { move(-1); });
  next.addEventListener('click', function () { move(1); });
})();
